export class UpdatePassword {
    constructor(public passwordResetCode: string, public password: string) { }
}
